import clsx from 'clsx'
import React, { forwardRef, useContext } from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'
import ThemeContext from './ThemeContext'

const withTheme = (name) => (Component) => {
	const WithTheme = forwardRef(function WithTheme(props, ref) {
		const { className, ...other } = props

		const context = useContext(ThemeContext)

		const theme = context?.theme || 'light'

		return <Component ref={ref} theme={theme} className={clsx(`${name}--theme-${theme}`, className)} {...other} />
	})

	WithTheme.displayName = `WithTheme(${Component.displayName || Component.name || ''})`

	hoistNonReactStatics(WithTheme, Component)

	return WithTheme
}

export default withTheme
